import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as variableOverrides from '../../../../../../variable-overrides'
import type * as currentRendering from '../../../feature'
import type { Feature } from '../feature'

// TODO: Explain
export const triggerSegmentRendering = store.effects.create(
  (
    feature: Feature,
    currentRenderingFeature: currentRendering.Feature,
    variablesFeature: variableOverrides.Feature,
  ) =>
    rxjs
      .merge(
        // We listen for when the page starts and finishes rendering. When it
        // starts rendering we stop all widget rendering requests, and when it
        // finishes rendering we start all widget rendering requests. We tie
        // widget renderings to the page renderings in this way to avoid
        // unnecessary widget renderings in response to all the changes that
        // happen during page render
        currentRenderingFeature.actions.render.request.observe(),
        currentRenderingFeature.actions.render.success.observe(),
      )
      .pipe(
        rxjs.switchMap(action =>
          // if we are in the middle of the request
          action.op.status === 'request'
            ? // cancel inner observable(s)
              rxjs.EMPTY
            : // if we are done with the request we start the widget rendering
              // requests and maintaining the stream open util the next request
              rxjs.combineLatest({
                pageContext:
                  currentRenderingFeature.selectors.context.asObservable,
                segments:
                  feature.selectors.segmentsThatRequireRendering.asObservable,
                variables:
                  // We need the context to get the variables
                  currentRenderingFeature.selectors.context.asObservable.pipe(
                    rxjs.switchMap(context =>
                      context
                        ? variablesFeature.selectors.getVariableOverrides({
                            page: context,
                          }).asObservable
                        : rxjs.of(undefined),
                    ),
                  ),
              }),
        ),
        rxjs.mergeMap(({ pageContext, segments, variables }) =>
          pageContext
            ? rxjs.from(segments).pipe(
                rxjs.map(({ alias }) =>
                  feature.actions.render.request
                    .from('triggerSegmentRendering (effect)')
                    .create({
                      ...pageContext,
                      alias,
                      variables,
                    }),
                ),
              )
            : rxjs.EMPTY,
        ),
      ),
)
